import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material';
import { tokens } from '../theme';
import { useTranslation } from 'react-i18next';
import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike';
import TimerIcon from '@mui/icons-material/Timer';
import SpeedIcon from '@mui/icons-material/Speed';
import BoltIcon from '@mui/icons-material/Bolt';
import TerrainIcon from '@mui/icons-material/Terrain';
import { convertDistance, convertSpeed, convertElevation, getUnits } from '../pages/WorkoutAnalysisV2';
import StatBox from './StatBox';

const WorkoutSummaryStats = ({ workoutData }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const units = getUnits();

  const {
    total_distance,
    total_duration,
    avg_speed,
    avg_power,
    total_elevation_gain,
    total_elevation_loss
  } = workoutData;

  const distanceLabel = units === 'imperial' ? 'mi' : 'km';
  const speedLabel = units === 'imperial' ? 'mph' : 'km/h';
  const elevationLabel = units === 'imperial' ? 'ft' : 'm';

  return (
    <Box
      display="grid"
      gridTemplateColumns="repeat(12, 1fr)"
      gap="20px"
      mb={4}
    >
      <Box gridColumn="span 2">
        <StatBox
          title={t('distance')}
          value={`${(convertDistance(total_distance, units).toFixed(2))} ${distanceLabel}`}
          icon={<DirectionsBikeIcon sx={{ fontSize: "32px" }} />}
          iconColor={colors.chartColors[12]}
        />
      </Box>
      <Box gridColumn="span 2">
        <StatBox
          title={t('duration')}
          value={`${Math.floor(total_duration / 3600)}h ${Math.floor((total_duration % 3600) / 60)}m`}
          icon={<TimerIcon sx={{ fontSize: "32px" }} />}
          iconColor={colors.chartColors[0]}
        />
      </Box>
      <Box gridColumn="span 2">
        <StatBox
          title={t('avgSpeed')}
          value={`${convertSpeed(avg_speed, units).toFixed(1)} ${speedLabel}`}
          icon={<SpeedIcon sx={{ fontSize: "32px" }} />}
          iconColor={colors.chartColors[2]}
        />
      </Box>
      <Box gridColumn="span 2">
        <StatBox
          title={t('avgPower')}
          value={`${avg_power.toFixed(0)} W`}
          icon={<BoltIcon sx={{ fontSize: "32px" }} />}
          iconColor={colors.chartColors[4]}
        />
      </Box>
      <Box gridColumn="span 2">
        <StatBox
          title={t('elevationGain')}
          value={`${convertElevation(total_elevation_gain, units).toFixed(0)} ${elevationLabel}`}
          icon={<TerrainIcon sx={{ fontSize: "32px" }} />}
          iconColor={`color-mix(in srgb, ${colors.chartColors[1]} 70%, black)`}
        />
      </Box>
      <Box gridColumn="span 2">
        <StatBox
          title={t('elevationLoss')}
          value={`${convertElevation(total_elevation_loss, units).toFixed(0)} ${elevationLabel}`}
          icon={<TerrainIcon sx={{ fontSize: "32px" }} />}
          iconColor={colors.chartColors[1]}
        />
      </Box>
    </Box>
  );
};

export default WorkoutSummaryStats;
